import { useMemo } from "react";
import { useFetch } from "../useFetch";
import { PagedResultDto } from "../../types/api/PagedResultDto";
import { Container } from "../../types/api/guide/container.types";
import { containerService } from "../../services/guide/container-service";

export const useFetchPagedContainer = (page: number, pageSize: number, name?: string) => {
    const params = useMemo(() => [page, pageSize, name] as const, [page, pageSize, name]);
    return useFetch<PagedResultDto<Container>>(containerService.getPaged, params as unknown as [number, number, string?]);
};
